<script setup>
import { computed, ref } from 'vue';
import SportLiveTvFilterOverview from '@/sport-live-tv/components/sport-live-tv-filter-overview.vue';
import SportLiveTvFilterStep from '@/sport-live-tv/components/sport-live-tv-filter-step.vue';
import { useSportLiveTvFilterDraft } from '@/sport-live-tv/composables/use-sport-live-tv-filter-draft';
import { useSportLiveTvFilterGroups } from '@/sport-live-tv/composables/use-sport-live-tv-filter-groups';

const props = defineProps({
  categories: { type: Array, required: true },
  teams: { type: Array, required: true },
  selection: { type: Object, required: true },
});

const emit = defineEmits(['clear', 'apply']);

const { draft, toggle, clear } = useSportLiveTvFilterDraft(() => props.selection);
const groups = useSportLiveTvFilterGroups({ categories: () => props.categories, teams: () => props.teams, draft });

const activeGroupKey = ref(null);

const activeGroup = computed(() => groups.value.find(({ key }) => key === activeGroupKey.value));

const openGroup = (key) => {
  activeGroupKey.value = key;
};

const closeGroup = () => {
  activeGroupKey.value = null;
};

const clearAll = () => {
  clear();
  emit('clear');
};
</script>

<template>
  <div class="sport-live-tv-filter-panel">
    <SportLiveTvFilterStep v-if="activeGroup" :group="activeGroup" @toggle="toggle" @done="closeGroup" />
    <SportLiveTvFilterOverview v-else :groups="groups" @toggle="toggle" @open="openGroup" @clear="clearAll" @apply="emit('apply', draft)" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-filter-panel {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 640px;
  max-width: calc(100vw - 64px);
  padding: 20px;
  border-radius: 12px;
  background-color: $black18;
  box-shadow: 0 8px 32px rgba($black, 0.6);

  @include mobile-sm-max {
    position: fixed;
    top: auto;
    right: 0;
    bottom: 0;
    left: 0;
    width: auto;
    max-width: 100%;
    padding: 16px;
    border-radius: 12px 12px 0 0;
  }
}
</style>
